import './Footer.css';

export interface FooterProps {
  onGoDocs: () => void;
  onGoPricing: () => void;
}

export function Footer({ onGoDocs, onGoPricing }: FooterProps) {
  return (
    <div className="land-footer land-container">
      <span className="land-footer__brand">
        <span className="land-footer__wordmark">dedupr</span>
        <span className="land-footer__dot" />
        <span className="land-footer__copy">© 2026 Dedupr Ltd · London</span>
      </span>
      <div className="land-footer__links">
        <button className="land-btn land-btn--plain land-footer__link" onClick={onGoDocs}>
          Documentation
        </button>
        <button className="land-btn land-btn--plain land-footer__link" onClick={onGoPricing}>
          Pricing
        </button>
        <a href="#systems">Connectors</a>
        <a href="#decide">Security</a>
        {/* Residency and the DPA are enterprise terms, so they live on the
            pricing page's enterprise section rather than at #pricing, which is
            where this pointed until 2026-07-30. */}
        <button className="land-btn land-btn--plain land-footer__link" onClick={onGoPricing}>
          DPA &amp; residency
        </button>
      </div>
    </div>
  );
}
